export const namespaced = true

export const state = () => ({
  sidebarItems: [], // список элементов сайдбара
  isLoaded: false, // загрузились ли данные
  activeCode: 'main', // текущий активный код (по умолчанию "main")
  prostoData: null, // текущий активный код (по умолчанию "main")
})

export const getters = {
  CODE_NAMES: (state) =>
    (state.sidebarItems || []).reduce((acc, it) => {
      if (it?.code) acc[it.code] = it.name || ''
      return acc
    }, {}),

  IMG_BY_CODE: (state) =>
    (state.sidebarItems || []).reduce((acc, it) => {
      if (it?.code) acc[it.code] = it.img ?? null
      return acc
    }, {}),

  SECTION_TYPE:
    (state, getters) =>
    (path = '') => {
      const parts = String(path).split('?')[0].split('/')
      const code = parts[2]
      return parts.length === 3 && getters.CODE_NAMES[code] ? code : ''
    },

  TITLE:
    (state, getters) =>
    (path = '') => {
      const parts = String(path).split('?')[0].split('/')
      const code = parts[2]
      if (path.includes('author')) {
        return 'Авторские материалы'
      }
      return parts.length === 3 && getters.CODE_NAMES[code]
        ? getters.CODE_NAMES[code]
        : 'Все материалы'
    },

  TITLE_BY_CODE: (state) => (code) => {
    const item = (state.sidebarItems || []).find((i) => i?.code === code)
    return item?.name || 'Все материалы'
  },

  IMG_FOR_CODE: (state) => (code) => {
    const item = (state.sidebarItems || []).find((i) => i?.code === code)
    return item?.imgFullUrl || null
  },

  IS_LOADED: (state) => state.isLoaded,

  ACTIVE_CODE: (state) => state.activeCode,

  SIDEBAR_ITEMS: (state) => state.sidebarItems,

  PROSTO_DATA: (state) => state.prostoData,
}

export const mutations = {
  SET_SIDEBAR_ITEMS(state, items) {
    state.sidebarItems = Array.isArray(items) ? items : []
    state.isLoaded = true
  },
  RESET(state) {
    state.sidebarItems = []
    state.isLoaded = false
    state.activeCode = 'main'
  },
  SET_ACTIVE_CODE(state, code) {
    state.activeCode = code
  },
  SET_PROSTO_DATA(state, data) {
    state.prostoData = data
  },
}

export const actions = {
  setSidebarItems({ commit }, items) {
    commit('SET_SIDEBAR_ITEMS', items)
  },
  reset({ commit }) {
    commit('RESET')
  },
  setActiveCode({ commit }, code) {
    commit('SET_ACTIVE_CODE', code)
  },
}
